import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Input } from 'reactstrap';

import '../../index.css';
import './SelectorInput.css';

class SelectorInput extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    dataTestLabel: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    placeHolder: PropTypes.string,
    defaultValue: PropTypes.string,
    onlyNumeric: PropTypes.bool,
    onlyCharacters: PropTypes.bool,
    withDecimals: PropTypes.bool,
    readOnly: PropTypes.bool,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.string,
    customClasses: PropTypes.string,
    onChangeEvent: PropTypes.func,
    onBlurEvent: PropTypes.func,
    isValid: PropTypes.bool,
    tabIndex: PropTypes.string,
    maxValue: PropTypes.number,
    preventChangeValue: PropTypes.bool,
    dirtyEvent: PropTypes.func,
    edited: PropTypes.bool
  }

  static defaultProps = {
    title: '',
    dataTestLabel: 'data-test-id-input',
    name: '',
    type: 'text',
    placeHolder: '',
    defaultValue: '',
    onlyNumeric: false,
    onlyCharacters: false,
    withDecimals: false,
    readOnly: false,
    isDisabled: false,
    maxLength: '',
    customClasses: '',
    onChangeEvent: null,
    onBlurEvent: null,
    isValid: true,
    tabIndex: '',
    maxValue: 0,
    preventChangeValue: false,
    dirtyEvent: () => {},
    edited: false
  }

  constructor(props) {
    super(props);
    this.state = {
      value: this.props.defaultValue
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.setStateOnly(this.props.defaultValue);
    }
  }

  setStateOnly = (value) => {
    this.setState({ value });
  }

  isNumeric = value => !(value !== 8 && value !== 0
    && (value < 46 || value > 57 || value === 47
      || (!this.props.withDecimals && value === 46)));

  onKeyPress = (event) => {
    if ((this.props.onlyNumeric && !(this.isNumeric(event.which)))
      || (this.props.onlyCharacters && this.isNumeric(event.which))) {
      event.preventDefault();
    }
  }

  hasNumber = value => /\d/.test(value);

  checkNumeric = (value, maxValue) => {
    if (isNaN(value)) {
      return false;
    }
    if (maxValue > 0 && Number(value) > maxValue) {
      this.setState({
        value: maxValue
      });
      return false;
    }
    return true;
  }

  onChangeHandler = (event) => {
    const {
      onlyCharacters,
      onlyNumeric,
      onChangeEvent,
      maxValue,
      preventChangeValue,
      dirtyEvent
    } = this.props;

    if (event && event.target) {
      const { name, value } = event.target;

      if (preventChangeValue) {
        dirtyEvent();
        return;
      }

      if (onlyNumeric && !this.checkNumeric(value, maxValue)) {
        event.preventDefault();
        return;
      }
      if (onlyCharacters && this.hasNumber(value)) {
        event.preventDefault();
        return;
      }

      this.setState({
        value
      }, () => {
        if (onChangeEvent != null) {
          onChangeEvent(value, name);
        }
      });
    }
  }

  onBlurHandler = (event) => {
    const { value } = this.state;

    const { defaultValue, preventChangeValue, onBlurEvent } = this.props;

    if (onBlurEvent !== null) {
      if (preventChangeValue) return;

      if (event === null) return;

      if (event.target === null) return;

      if (defaultValue === value) return;

      onBlurEvent(value, event.target.name);
    }
  }

  render() {
    const { value } = this.state;

    const {
      title,
      dataTestLabel,
      type,
      name,
      placeHolder,
      readOnly,
      isDisabled,
      maxLength,
      customClasses,
      isValid,
      tabIndex,
      edited
    } = this.props;

    const componentClassName = `selector-input-component h-100 auto-margin ${customClasses}`;
    const inputClassName = `custom-input-component ${isValid ? '' : 'invalid-input'} ${edited ? 'edited' : ''}`;

    return (
      <Row className={componentClassName}>
        {(title !== '') &&
          <Col sm="12" className="component-title no-padding-left">
            {title}
          </Col>
        }
        <Col sm="12" className="component-form no-padding align-self-end">
          {(readOnly)
            ?
              <label className="read-only-label">
                {value}
              </label>
            :
              <Input
                tabIndex={tabIndex}
                className={inputClassName}
                data-test-id={dataTestLabel}
                type={type}
                name={name}
                value={value}
                placeholder={placeHolder}
                disabled={isDisabled}
                onChange={this.onChangeHandler}
                onBlur={this.onBlurHandler}
                onKeyPress={this.onKeyPress}
                maxLength={maxLength}
              />
          }
        </Col>
      </Row>
    );
  }
}

export default SelectorInput;
